export const enum ComponentNames {
  Position = 'Position',
  PositionInterpolate = 'PositionInterpolate',
  Speed = 'Speed',
  DrawableIndex = 'DarawableIndex',
  ReelIndex = 'ReelIndex',
  LineIndex = 'LineIndex',
  EnumerationIndex = 'EnumerationIndex',
  Visible = 'Visible',
  RelocatedFlag = 'RelocatedFlag',
  AccelerationInterpolate = 'AccelerationInterpolate',
  BrakingInterpolate = 'BrakingInterpolate',
  AfterBraking = 'AfterBraking',
  FinalPosition = 'FinalPosition',
  FinalEnumerationIndex = 'FinalEnumerationIndex',
  PositionInReel = 'PositionInReel',
  CalculationReadyFlag = 'CalculationReadyFlag',
  BrakingCalculationInfo = 'BrakingCalculationInfo',
  ProcessAnimation = 'ProcessAnimation',
  DrawAnimation = 'DrawAnimation',
  KeepLastAnimationFrame = 'KeepLastAnimationFrame',
  MaxSpeed = 'MaxSpeed',
  BouncingPosition = 'BouncingPosition',
  ShowStaticAnimation = 'ShowStaticAnimation',
  StickyIcon = 'StickyIcon',
  FreeFallingIcon = 'FreeFallingIcon',
  ToRemoveIndex = 'ToRemoveIndex',
  CheckIconIndex = 'CheckIcon',
  SubstituteIcon = 'SubstituteIcon',
  ShiftMarker = 'ShiftIcon',
  DisableBlureIconIndex = 'DisableBlureIconIndex',
  SingleSpinningIndex = 'SingleSpinningIndex',
  TopLayerIcon = 'TopLayerIcon',
  IconNode = 'IconNode',
  LoadSingleScene = 'LoadSingleScene',
  IconValue = 'IconValue',
  NeedUpdate = 'NeedUpdate',
  RemoveEntity = 'RemoveEntity',
}

// TODO: Increment count, if you will add new component!
export const ComponentNamesCount = 40;
